import { WpDataRowParam } from '../model/data-row/wp-data-row-param.model';
import { ViewRow } from '../model/view/view-row.model';

export function wpAddDataRowParam(
    parentRowParams: WpDataRowParam[],
    r: ViewRow,
): WpDataRowParam[] {
    const nextParentRowParams = [...parentRowParams];
    const vrr = r.row.individual ?? r.row?.peopleDetail;
    nextParentRowParams.push({
        segmentIdentifier: r.segmentIdentifier,
        segmentEntityType: r.segmentEntityType,
        managerId: vrr.managerId,
        userId: vrr.userId,
        dataRangeId: vrr.dataRangeId ?? -1,
        startDateDataRange: vrr.startDateDataRange,
        endDateDataRange: vrr.endDateDataRange,
        evaluationRangeId: vrr.evaluationRangeId ?? -1,
        isOaMetric: vrr.isOaMetric,
        metricId: r.row?.peopleDetail?.metricId,
        behaviourId: r.row?.peopleDetail?.behaviourId,
        subBehaviourId: r.row?.peopleDetail?.subBehaviourId,
    });
    return nextParentRowParams;
}
